/* eslint no-shadow: 0 */

import actions from './actions';
import mutations from './mutations';

const state = {
  // safe for work mode
  sfwMode: 0,

  // random bob indexes for the top page carousel
  bobIndexes: [],
};

const getters = {
  sfwMode: state => state.sfwMode,
  bobIndexes: state => state.bobIndexes,
};

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default module;
